document.addEventListener("DOMContentLoaded", () => {
    function clearStorage() {
        let session = sessionStorage.getItem("register")

        if (session == null) {
            localStorage.removeItem("currentChatWindow")
            localStorage.removeItem("userJourney")
        }
        sessionStorage.setItem("register", 1)
    }

    clearStorage()
    ;(function chatBotInit() {
        const chatBotContainer = document.querySelector(".riverty-chat-bot-container")
        const header = document.querySelector(".header")
        const prevBtn = document.querySelector(".riverty-chat-bot-header-prev-page")
        if (chatBotContainer) {
            const form = chatBotContainer.querySelector(".riverty-chat-bot-send-message")
            const chatWindows = chatBotContainer.querySelectorAll(".riverty-chat-bot-content")
            const chatBot = chatBotContainer.querySelector(".riverty-chat-bot")
            const chatBtn = document.querySelector(".riverty-chat-bot-btn")

            if (!localStorage.getItem("userJourney")) {
                localStorage.setItem("userJourney", JSON.stringify(new Array()))
            }

            const userJourney = JSON.parse(localStorage.getItem("userJourney"))
            const textarea = chatBotContainer.querySelector(".jsTextArea")

            ;(function textAreaResize() {
                if (textarea) {
                    textarea.addEventListener("input", () => {
                        textarea.style.height = `0`
                        textarea.style.height = `${textarea.scrollHeight}px`
                    })
                }
            })()
            ;(function chatBotSubmit() {
                if (form) {
                    form.addEventListener("submit", async (e) => {
                        e.preventDefault()

                        if (textarea && textarea.value.length) {
                            const response = await fetch(form.action, { method: "POST", body: new FormData(form) })
                            chatWindows.forEach((item) => {
                                if (item.dataset.step === "1") {
                                    item.classList.remove("visible")
                                    localStorage.setItem("currentChatWindow", "Initial_State")
                                }

                                if (item.dataset.step === "2") {
                                    item.classList.add("visible")
                                    localStorage.setItem("currentChatWindow", "Select_Options")
                                }
                            })
                        }
                    })
                }
            })()

            if (localStorage.getItem("currentChatWindow")) {
                const id = localStorage.getItem("currentChatWindow")
                chatWindows.forEach((item) => {
                    item.classList.remove("visible")

                    if (item.id === id) {
                        item.classList.add("visible")
                    }
                })
            }

            const switchScreens = (e, link, currentChatWindow) => {
                const currentLink = link
                if (currentLink) {
                    const currentHref = currentLink.getAttribute("href")
                    if (currentHref) {
                        chatWindows.forEach((item) => {
                            if (currentHref.includes("#")) {
                                item.classList.remove("visible")

                                if (`#${item.id}` === currentHref) {
                                    e.preventDefault()
                                    item.classList.add("visible")
                                    prevBtn.classList.remove("hidden")
                                    userJourney.push(currentChatWindow.id)
                                    localStorage.setItem("userJourney", JSON.stringify(userJourney))
                                    if (currentChatWindow) {
                                        prevBtn.setAttribute("href", `#${currentChatWindow.id}`)
                                        localStorage.setItem("currentChatWindow", `${item.id}`)
                                    }
                                }
                            }
                        })
                    }
                }
            }

            const goBackInit = (arr, link) => {
                const currentChatWindow = chatBotContainer.querySelector(".riverty-chat-bot-content.visible")
                const lastEl = arr[arr.length - 1]
                if (currentChatWindow) {
                    if (arr.length) {
                        link.setAttribute("href", `#${lastEl}`)
                        link.classList.remove("hidden")
                    }
                }

                if (arr.length <= 0) {
                    link.classList.add("hidden")
                }
            }

            const goBack = (arr, link) => {
                if (arr.length) {
                    const lastEl = arr[arr.length - 1]

                    chatWindows.forEach((item) => {
                        item.classList.remove("visible")

                        if (lastEl.includes(item.id)) {
                            item.classList.add("visible")
                            link.setAttribute("href", `#${item.id}`)
                            localStorage.setItem("currentChatWindow", `${item.id}`)
                        }
                    })

                    if (arr.length <= 1) {
                        link.classList.add("hidden")
                    }

                    arr.pop()
                    localStorage.setItem("userJourney", JSON.stringify(arr))
                }
            }

            goBackInit(userJourney, prevBtn)

            document.addEventListener("click", (e) => {
                if (e.target.closest(".riverty-chat-bot-container a:not(.riverty-chat-bot-header-prev-page)")) {
                    const currentChatWindow = e.target.closest(".riverty-chat-bot-content")
                    const currentLink = e.target.closest(".riverty-chat-bot-container a")
                    switchScreens(e, currentLink, currentChatWindow)
                }

                if (e.target.closest(".riverty-chat-bot-header-prev-page")) {
                    goBack(userJourney, e.target.closest(".riverty-chat-bot-header-prev-page"))
                }

                if (e.target.closest(".riverty-chat-bot-header-close-btn")) {
                    chatBotContainer.classList.add("hidden")
                    chatBtn.classList.remove("hidden")
                    document.body.classList.remove("scroll-disabled")
                }

                if (e.target.closest(".riverty-chat-bot-btn")) {
                    chatBotContainer.classList.remove("hidden")
                    chatBtn.classList.add("hidden")

                    if (window.innerWidth <= 768) {
                        document.body.classList.add("scroll-disabled")
                    }
                }
            })
        }
    })()
})
